import { AppDataLocalTax } from '../../content/app-data-ltc-data';
import { PageHeaderSg, PrimaryButton } from '@scts-ui/component-library';
import { useTitleService } from '@scts/utilities';
import { useNavigate } from 'react-router-dom';

export const Home = () => {
  useTitleService('Home: Local Taxation Chamber');
  const nav = useNavigate();
  const startAppeal = () => {
    nav('/apply');
  };

  return (
    <>
      <PageHeaderSg headerText={'Local Taxation Chamber'} />

      <p>
              The Local Taxation Chamber is a First-tier Tribunal chamber which deals with council tax, council tax reduction, water charges, non-domestic rates and visitor levy appeals.
      </p>
      <p>The Local Taxation Chamber hear the following type of appeals:</p>
      <div className="d-flex flex-column d-md-flex flex-md-row">
        <ul>
          {AppDataLocalTax &&
            AppDataLocalTax.appealTypesCt.items.map((item, index) => (
              <li key={index}>{item.title}</li>
            ))}

          {AppDataLocalTax &&
            AppDataLocalTax.appealTypesNdr.items.map((item, index) => (
              <li key={index}>{item.title}</li>
            ))}

          {AppDataLocalTax &&
            AppDataLocalTax.appealTypesWater.items.map((item, index) => (
              <li key={index}>{item.title}</li>
            ))}

          {AppDataLocalTax &&
            AppDataLocalTax.appealTypesVla.items.map((item, index) => (
              <li key={index}>{item.title}</li>
            ))}
        </ul>
      </div>

      <PrimaryButton
        onClick={() => startAppeal()}
        buttonText="Start your appeal now"
      />
    </>
  );
};

export default Home;
